"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetShareItem = exports.getShareItem = exports.fetchHashItem = void 0;
var _fetching = require("@ori/fetching");
var _utils = require("../utils");
var _createListOfProducts = require("../utils/createListOfProducts");
var _externalUrl = require("./externalUrl");
var _utils2 = require("./utils");
/* istanbul ignore file -- api */

const fetchMediaItemStreams = async (mediaId, apiKey) => {
  const {
    apiDomain,
    apiVersion,
    isIncludeTaggedGalleries,
    wrapResponses
  } = _externalUrl.baseConfig;
  const mediaUrl = `${apiDomain}media/${mediaId}/streams?include_tagged_galleries=${Number(isIncludeTaggedGalleries)}&auth_token=${apiKey}&version=${apiVersion}&wrap_responses=${wrapResponses}`;
  const response = await (0, _externalUrl.getExternalUrl)(mediaUrl, {
    responseType: 'json'
  });
  return (0, _fetching.handleResponse)(response, {
    onError: () => [],
    onSuccess: ({
      data
    }) => {
      const result = data.data;
      return (0, _createListOfProducts.createListOfProducts)(result._embedded.stream);
    }
  });
};
const fetchHashItem = async (mediaId, apiKey) => {
  const {
    apiDomain,
    apiVersion
  } = _externalUrl.baseConfig;
  const mediaUrl = `${apiDomain}media/${mediaId}?auth_token=${apiKey}&version=${apiVersion}`;
  const response = await (0, _externalUrl.getExternalUrl)(mediaUrl, {
    responseType: 'json'
  });
  return (0, _fetching.handleResponse)(response, {
    onError: () => undefined,
    onSuccess: async ({
      data
    }) => {
      const result = data.data;
      const mediaItem = (0, _utils.createMediaItem)(result);
      mediaItem.products = await fetchMediaItemStreams(mediaId, apiKey);
      return mediaItem;
    }
  });
};
exports.fetchHashItem = fetchHashItem;
const getShareItem = async ({
  apiKey,
  shareItemId
}) => {
  const item = await fetchHashItem(shareItemId, apiKey);
  if (item?.id) {
    return item;
  }
  return undefined;
};
exports.getShareItem = getShareItem;
const useGetShareItem = ({
  apiKey,
  items,
  shareItemId
}) => {
  const {
    data,
    error
  } = (0, _fetching.useSWR)((0, _utils2.shouldFetchShareItem)(items, shareItemId) ? [shareItemId, apiKey] : null, async () => getShareItem({
    apiKey,
    shareItemId: shareItemId ?? ''
  }), {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    revalidateIfStale: false
  });
  return {
    data,
    isLoading: data === undefined && error === undefined
  };
};
exports.useGetShareItem = useGetShareItem;
